<template>
  <div class="box box_mm">
    <div class="box_main">
      <div class="search_box">
        <div class="search_item">
          <span style="width: 0.8rem">标题：</span>
          <el-input
            v-model="searchinput"
            placeholder="请输入"
            style="width: 2rem"
          ></el-input>
        </div>
        <div class="search_item">
          <span style="width: 0.8rem">分类：</span>
          <el-select
            v-model="searchfenlei"
            placeholder="请选择"
            filterable
            clearable
            style="width: 2.3rem"
            @change="search"
          >
            <el-option
              v-for="item in classifyData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="search_item">
          <el-button type="primary" @click="search">搜索</el-button>
          <!-- <el-button type="success" @click="addnew">新建公文处理单</el-button> -->
        </div>
      </div>
      <div class="box_cont">
        <div class="btn_list"></div>
        <div style="height: 76vh; box-sizing: border-box">
          <MyTable
            ref="zjlist"
            :tableData="tableData"
            :tableHeader="tableHeader"
            :showbm="true"
            :czwidth="310"
            @getdata="gettable"
            @changswitch="changswitch"
          >
            <template slot="btns" slot-scope="{ scope }">
              <el-button
                @click="showdetail2(scope.row)"
                type="primary"
                size="mini"
                >详情</el-button
              >
              <el-button
                @click="showdetail(scope.row)"
                type="primary"
                size="mini"
                >查看文件</el-button
              >
            </template>
          </MyTable>
        </div>
      </div>
    </div>

    <detail
      v-if="showtcdetail"
      :id="nowid"
      @closedetail="showtcdetail = false"
    ></detail>

    <detail_tcsj
      v-if="showtcsjdetail"
      :id="nowid"
      @closedetail="showtcsjdetail = false"
    ></detail_tcsj>
  </div>
</template>

<script>
import detail from "../detail_tc";
import detail_tcsj from "../detail_tcsj";
export default {
  components: {
    detail,
    detail_tcsj,
  },
  data() {
    return {
      searchinput: "",
      searchfenlei: "",
      classifyData: [],
      tableHeader: [
        {
          prop: "id",
          name: "序",
          width: "50",
        },
        {
          prop: "name",
          name: "标题",
          width: "",
        },
        {
          prop: "sqmytype_name",
          name: "所属类别",
          width: "150",
        },
        {
          prop: "sqmychannel_name",
          name: "来源渠道",
          width: "150",
        },
        {
          prop: "gbtype",
          name: "是否挂办",
          width: "120",
        },
        {
          prop: "user_name",
          name: "发起人",
          width: "120",
        },
        {
          prop: "state",
          name: "状态",
          width: "120",
          type: "sqmy_type",
        },
        {
          prop: "createtime",
          name: "创建时间",
          width: "150",
        },
      ],
      tableData: [],
      showtcdetail: false,
      showtcsjdetail: false,
      nowid: "",
    };
  },
  mounted() {
    this.$post({
      url: "/api/sqmytype/index",
      params: {
        p: 1,
        size: 9999,
      },
    }).then((res) => {
      this.classifyData = res.list;
    });
    this.gettable();
  },
  methods: {
    showdetail2(row) {
      this.nowid = row.id;
      this.showtcsjdetail = true;
    },
    showdetail(row) {
      this.nowid = row.id;
      this.showtcdetail = true;
    },
    postdata(row) {},
    showeidt(row) {
      this.$router.push("/system/get_file/edit?id=" + row.id);
    },
    changswitch(row) {
      this.$post({
        url: "/api/room/edit",
        params: row,
      }).then((res) => {
        this.$message({
          type: "success",
          message: "操作成功!",
        });
        this.gettable();
      });
    },
    search() {
      this.$refs.zjlist.inputpage = 1;
      this.gettable();
    },
    gettable() {
      this.$post({
        url: "/api/sqmy/quanindex",
        params: {
          name: this.searchinput,
          sqmytype_id: this.searchfenlei,
          p: this.$refs.zjlist.inputpage,
          size: this.$refs.zjlist.pagesize,
          state: 5,
          hqtype: 2,
        },
      }).then((res) => {
        res.list.map((item) => {
          item.gbtype = item.gbtype == 2 ? "挂办" : "";
          return item;
        });
        this.tableData = res.list;
        this.$refs.zjlist.total = res.count;
      });
    },
    addnew() {
      this.$router.push("/system/get_file/add");
    },
    showdate(row) {
      this.$refs.myroomdate.dialogVisible = true;
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
};
</script>

<style lang="scss" scoped>
@import "../list.scss";
</style>
